module.exports = __webpack_public_path__ + "img/melitta.aee93fa5.png";